import { render, staticRenderFns } from "./CreativesPreview.vue?vue&type=template&id=c370b63c&scoped=true&"
import script from "./CreativesPreview.vue?vue&type=script&lang=js&"
export * from "./CreativesPreview.vue?vue&type=script&lang=js&"
import style0 from "./CreativesPreview.vue?vue&type=style&index=0&id=c370b63c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c370b63c",
  null
  
)

export default component.exports